import React from 'react'

const Section = ({ children, className }) => {
  return <div className={`px-4 py-8 ${className}`}>{children}</div>
}

export default Section
